module.exports = __webpack_public_path__ + "img/occidental-resort.4ee45a74.jpg";